import { render, staticRenderFns } from "./FlexColumns.vue?vue&type=template&id=2687efdb"
import script from "./FlexColumns.vue?vue&type=script&lang=js"
export * from "./FlexColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports